import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const CreateStripeDashboardLinkMutation = graphql.persisted(
  "CreateStripeDashboardLink",
  graphql(`
    mutation CreateStripeDashboardLink($input: CreateStripeDashboardLinkInput!) {
      createStripeDashboardLink(input: $input) {
        dashboardUrl
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { CreateStripeDashboardLinkMutation };

export function useCreateStripeDashboardLink() {
  return useMutation(CreateStripeDashboardLinkMutation);
}
